// https://github.com/makerbot/MBCoreUtils/blob/b337f84a9545d84da59d4e198b37a9769c4e358b/birdwing_codegen/contexts/tool_metadata.json

const tools = {
  0: {
    name: "invalid_id",
    pretty_name: "Unknown",
    id: 0,
    type_key: null,
    material_name: "unknown"
  },
  1: {
    name: "mark_11",
    pretty_name: "Smart Extruder 11.0",
    id: 1,
    type_key: "mk12",
    material_name: "PLA"
  },
  2: {
    name: "mark_11_mod_1",
    pretty_name: "Smart Extruder 11.1",
    id: 2,
    type_key: "mk12",
    material_name: "PLA"
  },
  3: {
    name: "mark_11_mod_2",
    pretty_name: "Smart Extruder 11.2",
    id: 3,
    type_key: "mk12",
    material_name: "PLA"
  },
  4: {
    name: "mark_11_mod_3",
    pretty_name: "Smart Extruder 11.3",
    id: 4,
    type_key: "mk12",
    material_name: "PLA"
  },
  5: {
    name: "mark_12",
    pretty_name: "Smart Extruder 12.0",
    id: 5,
    type_key: "mk12",
    material_name: "PLA"
  },
  6: {
    name: "mark_12_5",
    pretty_name: "Smart Extruder 12.5",
    id: 6,
    type_key: "mk12",
    material_name: "PLA"
  },
  7: {
    name: "mark_12_1",
    pretty_name: "Smart Extruder 12.1",
    id: 7,
    type_key: "mk12",
    material_name: "PLA"
  },
  8: {
    name: "mark_13",
    pretty_name: "Smart Extruder+",
    id: 8,
    type_key: "mk13",
    material_name: "PLA"
  },
  9: {
    name: "mark_12_2",
    pretty_name: "Smart Extruder 12.2",
    id: 9,
    type_key: "mk12",
    material_name: "PLA"
  },
  10: {
    name: "mark_12_3",
    pretty_name: "Smart Extruder 12.2.1",
    id: 10,
    type_key: "mk12",
    material_name: "PLA"
  },
  11: {
    name: "mark_12_4",
    pretty_name: "Smart Extruder 12.3",
    id: 11,
    type_key: "mk12",
    material_name: "PLA"
  },
  12: {
    name: "mark_12_6",
    pretty_name: "Smart Extruder 12.4",
    id: 12,
    type_key: "mk12",
    material_name: "PLA"
  },
  13: {
    name: "mark_12_7",
    pretty_name: "Smart Extruder 12.6",
    id: 13,
    type_key: "mk12",
    material_name: "PLA"
  },
  14: {
    name: "mark_13_impla",
    pretty_name: "Tough PLA Smart Extruder+",
    id: 14,
    type_key: "mk13_impla",
    material_name: "Tough PLA"
  },
  15: {
    name: "mark_13_1",
    pretty_name: "Smart Extruder+",
    id: 15,
    type_key: "mk13",
    material_name: "PLA"
  },
  16: {
    name: "mark_13_1_impla",
    pretty_name: "Tough PLA Smart Extruder+",
    id: 16,
    type_key: "mk13_impla",
    material_name: "Tough PLA"
  },
  17: {
    name: "mark_13_2",
    pretty_name: "Smart Extruder+",
    id: 17,
    type_key: "mk13",
    material_name: "PLA"
  },
  18: {
    name: "mark_13_2_impla",
    pretty_name: "Tough PLA Smart Extruder+",
    id: 18,
    type_key: "mk13_impla",
    material_name: "Tough PLA"
  },
  19: {
    name: "mark_13_3",
    pretty_name: "Smart Extruder+",
    id: 19,
    type_key: "mk13",
    material_name: "PLA"
  },
  20: {
    name: "mark_13_3_impla",
    pretty_name: "Tough PLA Smart Extruder+",
    id: 20,
    type_key: "mk13_impla",
    material_name: "Tough PLA"
  },
  21: {
    name: "mark_13_4",
    pretty_name: "Smart Extruder+",
    id: 21,
    type_key: "mk13",
    material_name: "PLA"
  },
  22: {
    name: "mark_13_4_impla",
    pretty_name: "Tough PLA Smart Extruder+",
    id: 22,
    type_key: "mk13_impla",
    material_name: "Tough PLA"
  },
  98: {
    name: "sketch_extruder",
    pretty_name: "Sketch Extruder",
    id: 98,
    type_key: "sketch_extruder",
    material_name: "PLA"
  },
  99: {
    name: "mark_13_experimental",
    pretty_name: "Experimental Extruder",
    id: 99,
    type_key: "mk13_experimental",
    material_name: "PLA"
  },
  100: {
    name: "mk14_0",
    pretty_name: "Model 1 Performance Extruder",
    id: 100,
    type_key: "mk14",
    material_name: "PLA"
  },
  101: {
    name: "mk14_s_0",
    pretty_name: "Support 2 Performance Extruder",
    id: 101,
    type_key: "mk14_s",
    material_name: "PVA"
  },
  102: {
    name: "mk14_hot_0",
    pretty_name: "Model 1 Performance Extruder",
    id: 102,
    type_key: "mk14_hot",
    material_name: "ABS"
  },
  103: {
    name: "mk14_hot_s_0",
    pretty_name: "Support 2 Performance Extruder",
    id: 103,
    type_key: "mk14_hot_s",
    material_name: "SR30"
  },
  104: {
    name: "mk14_e_0",
    pretty_name: "Labs Experimental Extruder",
    id: 104,
    type_key: "mk14_e",
    material_name: "ABS"
  }
};

const LABS_EXTRUDERS = [
  "mk13_experimental", "mk14_e"
];

const SKETCH_LARGE = {
  name: "sketch_l_extruder",
  type_key: "sketch_large"
}

module.exports = {
  LABS_EXTRUDERS,
  SKETCH_LARGE,
  tools
};
